import React from 'react';
import SnakeGame from './SnakeGame';
import './App.css';

function App() {
  return (
    <div className="App">
      <SnakeGame />
    </div>
  );
}

export default App;